import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ContactUsService } from '../../core/services/contact-us.service';

@Component({
  selector: 'app-contact-us-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact-us-modal.html',
})
export class ContactUsModal {
  form: FormGroup;
  isSubmitting = signal(false);
  submitted = signal(false);
  errorMessage = signal<string | null>(null);

  purposeOptions = [
    'Suggest a Feature',
    'Require Assistance',
    'Billing Enquiry',
    'Technical Support',
    'General Enquiry',
  ];

  constructor(
    private fb: FormBuilder,
    private contactUsService: ContactUsService,
  ) {
    this.form = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      cellNumber: ['', [Validators.required, Validators.pattern(/^\+?[0-9\s\-()]{7,20}$/)]],
      purposeOfEnquiry: ['', [Validators.required]],
      comments: ['', [Validators.required, Validators.minLength(10)]],
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set(null);

    this.contactUsService.submitContactUs(this.form.value).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.submitted.set(true);
        this.form.reset();
      },
      error: () => {
        this.isSubmitting.set(false);
        this.errorMessage.set('Failed to send your message. Please try again or email admin@medvisit.co.za directly.');
      },
    });
  }

  resetModal(): void {
    this.submitted.set(false);
    this.errorMessage.set(null);
    this.form.reset();
  }
}
